import React, {Component} from 'react';
import t from 'babel-plugin-yate/macro';
import * as Sentry from '@sentry/browser';

import Button from './Button';

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      eventId: null,
    };
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({eventId});
    });
  }

  reportError = () => {
    const {eventId} = this.state;

    const errorReportDialogOptions = {
      eventId,
    };

    Sentry.showReportDialog(errorReportDialogOptions);
  };

  reloadPage = () => window.location.reload();

  render() {
    const {children} = this.props;
    const {hasError} = this.state;

    if (hasError) {
      return (
        <div className="flex h-screen items-center justify-center text-center">
          <div className="-mt-32">
            <div className="text-36 pb-1">
              {t`An unknown error has occured`}. 🧐
            </div>

            <div className="pb-4 text-16">
              {t`You can help us by reporting what happened or you can reload the page.`}
            </div>

            <div className="pt-4">
              <span className="mr-8">
                <Button
                  title={t`Report`}
                  color="blue"
                  border={false}
                  onClick={this.reportError}
                />
              </span>

              <Button
                title={t`Reload page`}
                color="red"
                border={false}
                onClick={this.reloadPage}
              />
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default AppErrorBoundary;
